import React from "react";
import { useTranslation } from "react-i18next";
import { sumObjectsNumbers } from "common/helpers/summup";
import DateSelect from "components/bootstrap/DateSelect/DateSelect";
import ReportInfoBox from "components/ReportInfoBox";

import { handleSelectChange } from "./helper";

type ReportsStatsProps = {
  setStartDate: React.Dispatch<React.SetStateAction<Date>>;
  completedReports;
  selectedDatePeriod;
  setSelectedDatePeriod;
};
const ReportsStats = ({
  setStartDate,
  completedReports,
  selectedDatePeriod,
  setSelectedDatePeriod,
}: ReportsStatsProps) => {
  const { t } = useTranslation();
  let completedReportsArr;
  if (completedReports) {
    completedReportsArr = Object.entries(completedReports).map(
      ([key, value], index) => ({
        [key]: value,
        id: index,
      })
    );
  }
  return (
    <div>
      <div className="titleBox">
        <div className="title">{t("pictureOfTheSituation")}&nbsp;</div>
        <div>{t("completedReports")}</div>
        <div className="num">
          <span className="unset">(</span>
          {sumObjectsNumbers(completedReports)}
          <span className="unset">)</span>
        </div>
        <DateSelect
          className="fitContent"
          value={selectedDatePeriod}
          onChange={(e) => {
            setSelectedDatePeriod(e.target.value);
            handleSelectChange({
              e,
              setStartDate,
              isNeedToConverdDateFormat: false,
            });
          }}
        />
      </div>
      <div className="reportsInfoCon">
        {completedReportsArr?.map((dt) => (
          <div className="summaryBox" key={dt.id}>
            <ReportInfoBox completedReport={dt} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportsStats;
